import { render, staticRenderFns } from "./obj-input.vue?vue&type=template&id=428def3e&"
import script from "./obj-input.vue?vue&type=script&lang=js&"
export * from "./obj-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports